import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class DeleteTestDataService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  public delete(municipalityKey: string) {
    return this.http.delete(this.endpoint(`datapool`, `municipalities`, `alltestdata`, municipalityKey));
  }
}
